/* eslint-disable import/prefer-default-export */

export const formatDecimal = ({ value, min, max, locale, defaultValue = 0 }) => {
  if (!value) {
    return defaultValue
  }
  locale = locale.startsWith('es') ? 'en-US' : locale
  return value.toLocaleString(locale, { minimumFractionDigits: min, maximumFractionDigits: max })
}

export const formatNumber = (value, language = 'pt-BR') => {
  language = language.startsWith('es') ? 'en-US' : language
  return new Intl.NumberFormat(language, {
    style: 'decimal',
    minimumFractionDigits: 2
  }).format(value)
}
